import {JobStateType} from '../../../hooks/useStateFlag';
import {AssignMechanicType} from './AssignMechanicType';

export type JobType = {
  id?: string | null;
  postponeJobId?: string | null;
  withItemNeededAtUpdate?: boolean | null;
  state?: JobStateType | null;
  name?: string | null;
  orderVariantId?: string | null;
  description?: string | null;
  solution?: string | null;
  workTeam?: string | null;
  workTimeEstimated?: number | null;
  workTimeReal?: number | null;
  totalPriceEstimated?: number | null;
  repeatedRepair?: boolean | null;
  partsReturn?: boolean | null;
  priority?: number | null;
  partsRequest?: boolean | null;
  partsReady?: boolean | null;
  competencyId?: string | null;
  isUncategorized?: boolean | null;
  isServicePackage?: boolean | null;
  isDoNotApplyDiscount?: boolean | null;
  hasItems?: boolean | null;
  timeTrackingState?: string | null;
  assignMechanics?: (AssignMechanicType | null)[] | null;
  isServiceCampaign?: boolean | null;
  sparePartWarehouseState?: string | null;
  neededAt?: string | null;
  allowedActions?: string[] | null;
  isCarRental?: boolean | null;
  carRentalDetails?: {
    rentalOrderId?: string | null;
    state?: string | null;
    note?: string | null;
  } | null;
  serviceCampaignDetails?: {
    id?: string | null;
    platformCode?: string | null;
    serviceCode?: string | null;
    description?: string | null;
    defectCode?: string | null;
    startDate?: string | null;
    dueDate?: string | null;
  } | null;
  servicePackageDetails?: {
    id?: string | null;
    name?: string | null;
    number?: string | null;
    isLock?: boolean | null;
  } | null;
  isFixedPrice?: boolean | null;
  fixedPrice?: {
    isUniformVatType?: boolean | null;
    withoutVat?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
    vat?: {
      type?: string | null;
      amount?: number | null;
      currency?: string | null;
    } | null;
    withVat?: {
      amount?: number | null;
      currency?: string | null;
    } | null;
  } | null;
  serviceItems?: {
    itemsCount?: number;
    fullyReturnedItemsCount?: number;
  } | null;
};
